
























/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { StepMixin, StepStoreMixin } from '@mixin';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            store: {
                focus_area: null,
            }
        };
    },

    mixins: [
        StepMixin,
        StepStoreMixin
    ],
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Aandachtsgebied extends Vue {}

